
Monet.UI = Monet.UI || {};

Monet.UI.ListItemRender = (function () {

    return function (data, conf) {

        if (data) {

            this.elItem           = document.createElement('div');
            this.elItem.className = 'MonetUIListItem';
            this.elItem.innerHTML = data[conf.description];
            this.elItem.setAttribute('value', data.id);

            if (conf.action) {
                this.elItem.addEventListener('click', conf.action);
            }

            return this.elItem;

        } else {
            console.log ('No enough data to render list item');
        }

        return false;
    };

}());